import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../fichierCss/AccesRefusePilotage.css';

const AccesRefusePilotage = () => {
  const location = useLocation();
  const depuis = location?.state?.depuis || '/';

  return (
    <section className="acces-refuse-pilotage-page">
      <div className="acces-refuse-pilotage-card">
        <p className="acces-refuse-kicker">Acces refuse</p>
        <h1>Pilotage reserve aux administrateurs</h1>
        <p>
          Vous etes connecte, mais votre role ne permet pas d'acceder a cette page de pilotage.
          Seuls les membres avec le role <strong>Administrateur</strong> peuvent piloter les contenus.
        </p>

        <div className="acces-refuse-actions">
          <Link to="/" className="acces-refuse-btn secondaire">Retour a l'accueil</Link>
          <Link to={depuis} className="acces-refuse-btn primaire">Revenir a la page precedente</Link>
        </div>
      </div>
    </section>
  );
};

export default AccesRefusePilotage;
